import includes from 'lodash/includes'
import {
  BROADCAST_DEVICE_CONFIGURATION,
  IP_DEVICE_CONFIGURATION,
  DEFAULT_PRINTER_FILTER_CONFIG,
} from './constants'

export const getTitleIdByConfigurationType = (configurationType) => {
  switch (configurationType) {
    case BROADCAST_DEVICE_CONFIGURATION:
      return 'broadcastDevice'
    case IP_DEVICE_CONFIGURATION:
      return 'ipDevice'
    default:
      return ''
  }
}

export const getDeviceLabelIdByConfigurationType = (configurationType) => {
  switch (configurationType) {
    case BROADCAST_DEVICE_CONFIGURATION:
      return 'deviceName'
    case IP_DEVICE_CONFIGURATION:
      return 'ip'
    default:
      return ''
  }
}

export const hasPrinterConfiguration = (configurationType) => {
  const hasPrinterConfigurationTypes = [BROADCAST_DEVICE_CONFIGURATION]
  return includes(hasPrinterConfigurationTypes, configurationType)
}

export function byFilterConfig(filterConfig = DEFAULT_PRINTER_FILTER_CONFIG) {
  return (printer) =>
    !filterConfig.some((filter) => printer.name.includes(filter))
}
